/* eslint-disable no-return-assign */
/* eslint-disable consistent-return */
/* eslint-disable no-use-before-define */
/* eslint-disable @typescript-eslint/no-shadow */
import { differenceInYears, isValid, add } from 'date-fns';
import {
  cloneDeep, map, find, filter, reduce, pull, forEach, indexOf, isEmpty,
} from 'lodash-es';
import Vue from 'vue';

import apiUrls from '@/apiUrls.config';
import { ETransportValue } from '@/components/filtry/types/ETransportValue';
import { makeMutations } from '@/helper-functions/store/store';
import {
  parseQueryParams,
  groupLokalizacjeByType,
  mapLokalizacjeRelations,
  mapMiastaRelations,
  toggleCheckbox,
  mapRequiredFiltryBoczne,
  mapPopularneKierunki,
  setCurrentAdultAge,
  buildFilters,
} from '@/storeServices/filtry';
import filtryGlowneClicked from '~/googleTagManager/listing/filtry-glowne-clicked';

export const state = () => ({
  lokalizacje: null,
  kontynenty: null,
  panstwa: null,
  wybraneDokad: [], // ['hiszpania]
  wybraneSkad: [], // ['poznan']
  lokalizacjeFlat: null,
  miasta: null,
  popularneKierunki: [],
  data: null,
  typTransportu: 'AIR',
  datyUrodzenia: [],
  liczbaPokoi: 1,
  dowolnaLiczbaPokoi: false,
  disabledPokoje: false,
  initialTime: new Date(),
  defaultSetting: { Konfiguracja: {} },
  autoComplete: [],
  hoteloProdukt: [],
  hoteloProduktFromUrl: [],
  TerminMin: null,
  TerminMax: null,
  currentParams: null,
});
export const mutations = {
  ...makeMutations([
    'lokalizacje',
    'lokalizacjeFlat',
    'liczbaPokoi',
    'kontynenty',
    'panstwa',
    'miasta',
    'miastaFlat',
    'wybraneDokad',
    'wybraneSkad',
    'data',
    'typTransportu',
    'datyUrodzenia',
    'defaultSetting',
    'popularneKierunki',
    'autoComplete',
    'disabledPokoje',
    'hoteloProdukt',
    'TerminMin',
    'TerminMax',
    'currentParams',
    'hoteloProduktFromUrl',
    'dowolnaLiczbaPokoi',
  ]),
  addBirthDate(state, date) {
    date.type === 'dorosli'
      ? state.datyUrodzenia.push(date.payload)
      : state.datyUrodzenia.splice(getters.liczbaDzieci + 1, 0, date.payload);
  },
  subBirthDate(state, date) {
    date.type === 'dorosli' ? state.datyUrodzenia.pop() : state.datyUrodzenia.splice(getters.liczbaDzieci + 1, 1);
  },
  setDzieckoDate(state, payload) {
    Vue.set(state.datyUrodzenia, payload.index, payload.date);
  },
  pushWymaganeFiltry(state, payload) {
    const newArray = [...state[payload.key], payload.item];

    state[payload.key] = [...new Set(newArray)];
  },
  setHoteloProdukt(state, payload) {
    if (find(state.hoteloProdukt, { Nazwa: payload.Nazwa })) {
      pull(state.hoteloProdukt, find(state.hoteloProdukt, { Nazwa: payload.Nazwa }));
      state.hoteloProdukt = [...state.hoteloProdukt];
    } else {
      state.hoteloProdukt = [payload, ...state.hoteloProdukt];
    }
  },
  resetWybraneFiltry(state, payload) {
    if (payload.type === 'data') {
      state[payload.type] = null;
      return;
    }

    if (state.typTransportu === ETransportValue.dowolny && payload.type === 'wybraneSkad') {
      forEach(payload.wartosc, (child) => {
        pull(state[payload.type], child);
      });
      state[payload.type] = [...state[payload.type]];
    } else {
      pull(state[payload.type], payload.wartosc);
      state[payload.type] = [...state[payload.type]];
    }
  },
};
export const getters = {
  wybranyKierunek(state) {
    if (state.wybraneDokad.length === 1) {
      return find(state.lokalizacjeFlat, {
        Wartosc: state.wybraneDokad[0],
      }).Nazwa;
    }

    if (state.hoteloProdukt.length) {
      const el = find(state.hoteloProdukt, { TypWyswietlany: 'Wycieczka' });

      return el ? el.Nazwa : '';
    }
  },
  wybraneMiastoWyjazduText(state) {
    if (state.wybraneSkad.length !== 1) {
      return null;
    }

    return find(state.miastaFlat, {
      Wartosc: state.wybraneSkad[0],
    }).Nazwa;
  },
  wybraneKierunkiList(state) {
    return map(state.wybraneDokad, (lokalizacjaKey) => find(state.lokalizacjeFlat, {
      Wartosc: lokalizacjaKey,
    }));
  },
  liczbaDoroslych(state) {
    return filter(state.datyUrodzenia, (date) => differenceInYears(date, new Date()) <= -18).length;
  },
  liczbaDzieci(state, getters) {
    return state.datyUrodzenia.length - getters.liczbaDoroslych;
  },
  datyUrodzenia(state) {
    return state.datyUrodzenia;
  },
  shodShowLiczbaPokoiText(state) {
    return !state.dowolnaLiczbaPokoi && state.liczbaPokoi > 0;
  },
  polaDlaGTMV4(state, getters) {
    return {
      wybraneDokad: state.wybraneDokad,
      data: state.data,
      wybraneSkad: state.wybraneSkad,
      typTransportu: state.typTransportu,
      liczbaDzieci: getters.liczbaDzieci,
      liczbaDoroslych: getters.liczbaDoroslych,
      kierunki: state.lokalizacjeFlat,
      miasta: state.miastaFlat,
    };
  },
};

export const actions = {
  clearDataWylotu({ dispatch }) {
    dispatch('szukaj/clearDataWylotu', null, { root: true });
  },
  async fetchDefaultFilters({ commit }) {
    try {
      const response = await this.$http.$get(`${apiUrls.filtry}default`);

      commit('defaultSetting', response);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  },
  startKonfiguracja({ rootState, state, dispatch }, payload) {
    // Set konfiguracja from url params
    if (rootState.szukaj.paramsUrl.DatyUrodzenia && rootState.szukaj.paramsUrl.LiczbaPokoi) {
      let datyUrodzenia = rootState.szukaj.paramsUrl.DatyUrodzenia.map((date) => new Date(date));

      datyUrodzenia = setCurrentAdultAge(payload.adultBirthDate, datyUrodzenia);
      return dispatch('setKonfiguracja', {
        liczbaPokoi: parseInt(rootState.szukaj.paramsUrl.LiczbaPokoi, 10),
        datyUrodzenia,
      });
    }

    // Set konfiguracja from cookies
    if (this.$cookies && this.$cookies.get('wiek')) {
      let liczbaPokoi = state.defaultSetting.Konfiguracja.LiczbaPokoi;

      if (this.$cookies.get('liczbaPokoi')) {
        liczbaPokoi = this.$cookies.get('liczbaPokoi');
      }

      let datyUrodzenia = this.$cookies.get('wiek');

      datyUrodzenia = datyUrodzenia.map((date) => new Date(date));
      datyUrodzenia = setCurrentAdultAge(payload.adultBirthDate, datyUrodzenia);
      this.$cookies.set('wiek', JSON.stringify(datyUrodzenia), {
        expires: add(Date.now(), { years: 1 }),
      });
      const areDatesValid = reduce(datyUrodzenia, (reducer, date) => (reducer = reducer && isValid(date)), true);

      if (!areDatesValid) {
        return dispatch('setDefaultKonfiguracja', payload);
      }

      return dispatch('setKonfiguracja', {
        liczbaPokoi: parseInt(liczbaPokoi, 10),
        datyUrodzenia,
      });
    }

    return dispatch('setDefaultKonfiguracja', payload);
  },
  async fetchRegiony({ commit, state }) {
    try {
      const params = parseQueryParams(state);

      if (state.currentParams === params) return;

      const responseData = await this.$http.$get(`${apiUrls.filtry}pobierz-filtry-glowne${params}`);
      const groupedLokalizacje = groupLokalizacjeByType(responseData.Lokalizacje);
      const mappedLokalizacje = mapLokalizacjeRelations(responseData.Lokalizacje);

      commit('lokalizacje', mappedLokalizacje);
      commit('lokalizacjeFlat', responseData.Lokalizacje);
      commit('kontynenty', groupedLokalizacje.kontynent);
      commit('panstwa', groupedLokalizacje.panstwo);
      commit('miasta', mapMiastaRelations(responseData.Miasta));
      commit('miastaFlat', responseData.Miasta);
      commit('popularneKierunki', mapPopularneKierunki(responseData.PopularneKierunki, state.panstwa));
      commit('TerminMin', new Date(responseData.TerminMin));
      commit('TerminMax', new Date(responseData.TerminMax));
      commit('currentParams', params);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  },
  async fetchAutoComplete({ commit }, payload) {
    try {
      const response = await this.$http.$get(`${apiUrls.filtry}autocomplete?fraza=${payload}`);

      commit('autoComplete', response);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  },
  async fetchHoteloProdukt({ commit }, payload) {
    try {
      const response = await this.$http.$post(`${apiUrls.filtry}pobierz-hotelo-produkty`, payload);

      await commit('hoteloProdukt', response);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  },

  toggleDokadSelection({ commit, state, dispatch }, region = Object) {
    // accepts region Object {Wartosc: 'hiszpania', Nazwa: 'Hiszpania'}
    const wybraneDokad = cloneDeep(state.wybraneDokad);

    toggleCheckbox(state.panstwa, region, wybraneDokad);
    dispatch('clearDataWylotu');
    commit('wybraneDokad', wybraneDokad);
    filtryGlowneClicked();
  },
  clearDokad({ commit, dispatch }) {
    commit('wybraneDokad', []);
    commit('hoteloProdukt', []);
    dispatch('clearDataWylotu');
    filtryGlowneClicked();
  },
  toggleSkadSelection({ commit, state, dispatch }, miasto) {
    const wybraneSkad = cloneDeep(state.wybraneSkad);

    toggleCheckbox(state.miasta, miasto, wybraneSkad);
    dispatch('clearDataWylotu');
    commit('wybraneSkad', wybraneSkad);
    filtryGlowneClicked();
  },
  toggleSkadDowolneSelection({ commit, state, dispatch }, miasto) {
    const wybraneSkad = cloneDeep(state.wybraneSkad);

    forEach(miasto.WartoscArr, (child) => {
      const isInArray = indexOf(wybraneSkad, child) >= 0;

      if (isInArray) {
        pull(wybraneSkad, child);
      } else {
        wybraneSkad.push(child);
      }
    });
    commit('wybraneSkad', wybraneSkad);
    dispatch('clearDataWylotu');
  },
  clearSkad({ commit, dispatch }) {
    commit('wybraneSkad', []);
    dispatch('clearDataWylotu');
    filtryGlowneClicked();
  },
  changeDate({ commit, dispatch }, payload) {
    commit('data', payload);
    dispatch('clearDataWylotu');
    filtryGlowneClicked();
  },
  resetWybrane({ state, dispatch, commit }, payload) {
    dispatch('clearDataWylotu');
    if (payload.type === 'typTransportu') {
      const { wybraneSkad } = state;

      dispatch('clearSkad');
      const el = find(state.miasta, { Wartosc: ETransportValue.dowolny });

      if (el) {
        const temp = [];

        commit('typTransportu', el.Wartosc);
        forEach(wybraneSkad, (item) => {
          forEach(el.Dzieci, (child) => {
            if (child.WartoscArr.includes(item)) {
              temp.push(...child.WartoscArr);
            }
          });
        });
        commit('wybraneSkad', temp);
        return;
      }
    }

    dispatch('resetWybraneFiltry', payload);
  },
  resetFiltryGlowne({ commit, state, dispatch }) {
    dispatch('clearDataWylotu');
    commit('wybraneDokad', []);
    commit('wybraneSkad', []);
    commit('data', null);
    const typTransportu = find(state.miasta, 'CzyDefault');

    if (typTransportu) commit('typTransportu', typTransportu.Wartosc);
  },
  async setWymaganeFiltry(context) {
    if (context.rootState.filtryBoczne.filtry) {
      mapRequiredFiltryBoczne(context.rootState.filtryBoczne.filtry, context);
    }

    // Filtry with obj PopularnyKierunek
    if (context.rootState.szukaj?.popularnyKierunek) {
      buildFilters(context.rootState.szukaj.popularnyKierunek, context);
      context.commit('szukaj/popularnyKierunek', null, { root: true });
      return;
    }

    // Filtry with obj routeInfo from routeAuth
    if (context.rootState.szukaj.routeInfo?.Filtr && !isEmpty(context.rootState.szukaj.routeInfo.Filtr)) {
      await buildFilters(context.rootState.szukaj.routeInfo.Filtr, context);
    }

    // Filtry with obj paramsUrl from Url params
    if (context.rootState.szukaj?.paramsUrl) {
      await buildFilters(context.rootState.szukaj.paramsUrl, context, true);
    }
  },
  addBirthDate({ commit, dispatch, state }, payload) {
    commit('addBirthDate', payload);
    this.$cookies.set('wiek', JSON.stringify(state.datyUrodzenia), {
      expires: add(Date.now(), { years: 1 }),
    });
    dispatch('clearDataWylotu');
    filtryGlowneClicked();
  },
  subBirthDate({ commit, dispatch, state }, payload) {
    commit('subBirthDate', payload);
    this.$cookies.set('wiek', JSON.stringify(state.datyUrodzenia), {
      expires: add(Date.now(), { years: 1 }),
    });
    dispatch('clearDataWylotu');
    filtryGlowneClicked();
  },
  changeDzieckoDate({ dispatch, commit, state }, payload) {
    commit('setDzieckoDate', payload);
    this.$cookies.set('wiek', JSON.stringify(state.datyUrodzenia), {
      expires: add(Date.now(), { years: 1 }),
    });
    dispatch('clearDataWylotu');
    filtryGlowneClicked();
  },
  liczbaPokoi({ commit, dispatch, state }, value) {
    commit('liczbaPokoi', value);
    this.$cookies.set('liczbaPokoi', state.liczbaPokoi, {
      expires: add(Date.now(), { years: 1 }),
    });
    dispatch('clearDataWylotu');
    filtryGlowneClicked();
  },
  setDefaultKonfiguracja({ state, commit }, payload) {
    const arrAdult = new Array(state.defaultSetting.Konfiguracja.Dorosli).fill(payload.adultBirthDate);
    const arrChildren = new Array(state.defaultSetting.Konfiguracja.Dzieci).fill(payload.childBirthDate);

    commit('datyUrodzenia', [...arrAdult, ...arrChildren]);
    commit('liczbaPokoi', payload.liczbaPokoi || state.defaultSetting.Konfiguracja.LiczbaPokoi);
    if (this.$cookies) {
      this.$cookies.set('wiek', JSON.stringify(state.datyUrodzenia), {
        expires: add(Date.now(), { years: 1 }),
      });
      this.$cookies.set('liczbaPokoi', state.liczbaPokoi, {
        expires: add(Date.now(), { years: 1 }),
      });
    }
  },
  setLiczbaPokoiFromUrl({ commit }, value) {
    commit('liczbaPokoi', value);
  },
  dowolnaLiczbaPokoi({ commit, dispatch }, value) {
    commit('dowolnaLiczbaPokoi', value);
    dispatch('clearDataWylotu');
    filtryGlowneClicked();
  },
  setKonfiguracja({ commit }, payload) {
    commit('liczbaPokoi', payload.liczbaPokoi);
    commit('datyUrodzenia', payload.datyUrodzenia);
  },
  resetWybraneFiltry({ commit, dispatch }, payload) {
    commit('resetWybraneFiltry', payload);
    dispatch('clearDataWylotu');
  },
  setHoteloProdukt({ commit, dispatch }, payload) {
    dispatch('clearDataWylotu');
    commit('setHoteloProdukt', payload);
  },
  reset({ dispatch, commit, state }, payload) {
    dispatch('clearDataWylotu');
    const arrAdult = new Array(state.defaultSetting.Konfiguracja.Dorosli).fill(payload.dataDorosly);
    const arrChildren = new Array(state.defaultSetting.Konfiguracja.Dzieci).fill(payload.dataDziecko);

    commit('wybraneDokad', []);
    commit('wybraneSkad', []);
    commit('hoteloProdukt', []);
    commit('disabledPokoje', false);
    commit('dowolnaLiczbaPokoi', false);
    commit('typTransportu', 'AIR');
    commit('datyUrodzenia', [...arrAdult, ...arrChildren]);
    commit('liczbaPokoi', state.defaultSetting.Konfiguracja.LiczbaPokoi);
  },
};
